var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-header-wrapper",
    [
      _c(
        "a-card",
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  staticClass: "table-head-ground",
                  attrs: { layout: "inline" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "table-layer" },
                    [
                      _c(
                        "a-form-item",
                        {
                          staticClass: "table-head-layout",
                          staticStyle: {
                            "max-width": "520px",
                            "min-width": "400px",
                          },
                          attrs: { label: "" },
                        },
                        [
                          _c("time-range-filter", {
                            ref: "timeRangeFilter",
                            attrs: { "default-type": "today" },
                            on: { change: _vm.handleTimeRangeChange },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("jeepay-text-up", {
                            attrs: {
                              placeholder: "Order ID",
                              msg: _vm.searchData.orderNo,
                            },
                            model: {
                              value: _vm.searchData.orderNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchData, "orderNo", $$v)
                              },
                              expression: "searchData.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: {
                                placeholder: "支付状态",
                                "default-value": "",
                              },
                              model: {
                                value: _vm.searchData.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchData, "state", $$v)
                                },
                                expression: "searchData.state",
                              },
                            },
                            _vm._l(_vm.PAYMENT_STATUS, function (status) {
                              return _c(
                                "a-select-option",
                                {
                                  key: status.value,
                                  attrs: { value: status.value },
                                },
                                [_vm._v(" " + _vm._s(status.label) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "table-page-search-submitButtons" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "search",
                                loading: _vm.btnLoading,
                              },
                              on: { click: _vm.queryFunc },
                            },
                            [_vm._v("搜索")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { icon: "reload" },
                              on: { click: _vm.resetForm },
                            },
                            [_vm._v("重置")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: {
                                type: "primary",
                                icon: "export",
                                loading: _vm.exportLoading,
                              },
                              on: { click: _vm.exportFunc },
                            },
                            [_vm._v(" 导出 ")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { icon: "export" },
                              on: { click: _vm.showExportRecords },
                            },
                            [_vm._v("导出记录")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c("OrderStatistics", {
            attrs: {
              statisticsData: _vm.statisticsData,
              loading: _vm.statisticsLoading,
              isPayOut: true,
            },
          }),
          _c("JeepayTable", {
            ref: "infoTable",
            attrs: {
              initData: true,
              reqTableDataFunc: _vm.reqTableDataFunc,
              tableColumns: _vm.tableColumns,
              searchData: _vm.searchData,
              rowKey: "payOrderId",
              tableRowCrossColor: true,
              pageSize: 100,
            },
            on: { btnLoadClose: _vm.handleLoadClose },
            scopedSlots: _vm._u([
              {
                key: "amountSlot",
                fn: function ({ record }) {
                  return [
                    _c("b", [_vm._v(_vm._s(_vm.formatAmount(record.amount)))]),
                  ]
                },
              },
              {
                key: "refundAmountSlot",
                fn: function ({ record }) {
                  return [_vm._v(_vm._s(_vm.formatAmount(record.refundAmount)))]
                },
              },
              {
                key: "payTypeSlot",
                fn: function ({ record }) {
                  return [
                    _vm._v(" " + _vm._s(_vm.getPayTypeText(record)) + " "),
                  ]
                },
              },
              {
                key: "stateSlot",
                fn: function ({ record }) {
                  return [
                    _c(
                      "a-tag",
                      {
                        key: record.state,
                        attrs: {
                          color: _vm.getPaymentStatusColor(record.state),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getPaymentStatusText(record.state)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "processStateSlot",
                fn: function ({ record }) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "a-tag",
                          {
                            key: record.state,
                            attrs: {
                              color: _vm.getPaymentStatusColor(record.state),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getPaymentStatusText(record.state)) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "notifySlot",
                fn: function ({ record }) {
                  return [
                    _c("a-badge", {
                      attrs: {
                        status:
                          record.notifyState === 1 ? "processing" : "error",
                        text: record.notifyState === 1 ? "已发送" : "未发送",
                      },
                    }),
                  ]
                },
              },
              {
                key: "cusNoSlot",
                fn: function ({ record }) {
                  return [
                    _c("div", { staticClass: "order-list" }, [
                      _c("p", { staticClass: "order-row" }, [
                        _c(
                          "span",
                          {
                            staticClass: "order-type",
                            staticStyle: {
                              color: "#729ed5",
                              background: "#e7f5f7",
                            },
                          },
                          [_vm._v("商户ID")]
                        ),
                        _vm._v(_vm._s(record.mchNo) + " "),
                      ]),
                      _c("p", { staticClass: "order-row" }, [
                        _c(
                          "span",
                          {
                            staticClass: "order-type",
                            staticStyle: {
                              color: "#729ed5",
                              background: "#e7f5f7",
                            },
                          },
                          [_vm._v("用户ID")]
                        ),
                        _vm._v(_vm._s(record.cusNo) + " "),
                      ]),
                    ]),
                  ]
                },
              },
              {
                key: "mchOrderNoSlot",
                fn: function ({ record }) {
                  return [
                    record.mchOrderNo
                      ? _c(
                          "div",
                          { staticClass: "order-row" },
                          [
                            _c(
                              "a-tooltip",
                              {
                                staticClass: "order-content",
                                staticStyle: { "font-weight": "normal" },
                                attrs: { placement: "bottom" },
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(record.mchOrderNo)),
                                  ]),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.changeStr2ellipsis(
                                        record.mchOrderNo,
                                        20
                                      )
                                    ) +
                                    " "
                                ),
                              ],
                              2
                            ),
                            _c("CopyButton", {
                              attrs: { text: record.mchOrderNo },
                            }),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "order-row" }, [
                          _c("span", [_vm._v("--")]),
                        ]),
                  ]
                },
              },
              {
                key: "payOrderIdSlot",
                fn: function ({ record }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "order-row" },
                      [
                        record.payOrderId.length > 20
                          ? _c(
                              "a-tooltip",
                              {
                                staticClass: "order-content",
                                staticStyle: { "font-weight": "normal" },
                                attrs: { placement: "bottom" },
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(record.payOrderId)),
                                  ]),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.changeStr2ellipsis(
                                        record.payOrderId,
                                        20
                                      )
                                    ) +
                                    " "
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        record.payOrderId
                          ? _c("CopyButton", {
                              attrs: { text: record.payOrderId },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "orderSlot",
                fn: function ({ record }) {
                  return [
                    _c("div", { staticClass: "order-list" }, [
                      _c(
                        "p",
                        {
                          staticClass: "order-row",
                          staticStyle: { "margin-bottom": "0" },
                        },
                        [
                          record.mchOrderNo.length > record.payOrderId.length
                            ? _c(
                                "a-tooltip",
                                {
                                  staticClass: "order-content",
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { placement: "bottom" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.changeStr2ellipsis(
                                          record.mchOrderNo,
                                          record.payOrderId.length
                                        )
                                      ) +
                                      " "
                                  ),
                                  record.mchOrderNo
                                    ? _c("CopyButton", {
                                        attrs: { text: record.mchOrderNo },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "span",
                                { staticStyle: { "font-weight": "normal" } },
                                [_vm._v(_vm._s(record.mchOrderNo))]
                              ),
                        ],
                        1
                      ),
                      record.channelOrderNo
                        ? _c(
                            "p",
                            {
                              staticStyle: {
                                "margin-bottom": "0",
                                "margin-top": "10px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#fff",
                                    background: "#e09c4d",
                                  },
                                },
                                [_vm._v("渠道")]
                              ),
                              record.channelOrderNo.length >
                              record.payOrderId.length
                                ? _c(
                                    "a-tooltip",
                                    {
                                      staticStyle: { "font-weight": "normal" },
                                      attrs: { placement: "bottom" },
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(record.channelOrderNo)),
                                        ]),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.changeStr2ellipsis(
                                              record.channelOrderNo,
                                              record.payOrderId.length
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    2
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticStyle: { "font-weight": "normal" },
                                    },
                                    [_vm._v(_vm._s(record.channelOrderNo))]
                                  ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "upiSlot",
                fn: function ({ record }) {
                  return [
                    _c("div", { staticClass: "order-row" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(record.upi?.length > 0 ? record.upi : "--")
                        ),
                      ]),
                    ]),
                  ]
                },
              },
              {
                key: "notifyStateSlot",
                fn: function ({ record }) {
                  return [
                    _c("a-badge", {
                      attrs: {
                        status:
                          record.notifyState === 1 ? "processing" : "error",
                        text: record.notifyState === 1 ? "已发送" : "未发送",
                      },
                    }),
                  ]
                },
              },
              {
                key: "opSlot",
                fn: function ({ record }) {
                  return [
                    _c(
                      "JeepayTableColumns",
                      [
                        _vm.$access("ENT_PAY_ORDER_VIEW")
                          ? _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: {
                                  click: function ($event) {
                                    return _vm.detailFunc(record.payOrderId)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("refund-modal", {
        ref: "refundModalInfo",
        attrs: { callbackFunc: _vm.searchFunc },
      }),
      [
        _c(
          "a-drawer",
          {
            attrs: {
              width: "50%",
              placement: "right",
              closable: true,
              visible: _vm.visible,
              title: _vm.visible === true ? "订单详情" : "",
            },
            on: { close: _vm.onClose },
          },
          [
            _c(
              "a-row",
              { attrs: { justify: "space-between", type: "flex" } },
              [
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "平台订单ID" } },
                          [
                            _c("a-tag", { attrs: { color: "purple" } }, [
                              _vm._v(
                                " " + _vm._s(_vm.detailData.payOrderId) + " "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "商户ID" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.mchNo) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "商户订单ID" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailData.mchOrderNo) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "商户名称" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.mchName) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "应用APPID" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.appId) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "订单状态" } },
                          [
                            _c(
                              "a-tag",
                              {
                                attrs: {
                                  color:
                                    _vm.detailData.state === 0
                                      ? "blue"
                                      : _vm.detailData.state === 1
                                      ? "orange"
                                      : _vm.detailData.state === 2
                                      ? "green"
                                      : _vm.detailData.state === 6
                                      ? ""
                                      : "volcano",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.detailData.state === 0
                                        ? "订单生成"
                                        : _vm.detailData.state === 1
                                        ? "支付中"
                                        : _vm.detailData.state === 2
                                        ? "支付成功"
                                        : _vm.detailData.state === 3
                                        ? "支付失败"
                                        : _vm.detailData.state === 4
                                        ? "已撤销"
                                        : _vm.detailData.state === 5
                                        ? "已退款"
                                        : _vm.detailData.state === 6
                                        ? "订单关闭"
                                        : "未知"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "支付金额" } },
                          [
                            _c("a-tag", { attrs: { color: "green" } }, [
                              _vm._v(" " + _vm._s(_vm.detailData.amount) + " "),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "手续费" } },
                          [
                            _c("a-tag", { attrs: { color: "pink" } }, [
                              _vm._v(_vm._s(_vm.detailData.mchFeeAmount)),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "商家费率" } },
                          [
                            _vm._v(
                              _vm._s(
                                "₹" +
                                  _vm.detailData.mchFeeAmount +
                                  "(" +
                                  _vm.detailData.mchFeeRate +
                                  "%" +
                                  (_vm.detailData.feeFixedAmount
                                    ? " + " + _vm.detailData.feeFixedAmount
                                    : "") +
                                  ")"
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "支付错误码" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.errCode) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "支付错误描述" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.errMsg) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "订单失效时间" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatTime(_vm.detailData.expiredTime)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "支付成功时间" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatTime(_vm.detailData.successAt)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "创建时间" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatTime(_vm.detailData.createdAt)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "更新时间" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatTime(_vm.detailData.updatedAt)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("a-divider"),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "商品标题" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.subject) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "商品描述" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.body) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "接口代码" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.ifCode) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "货币代码" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.currency) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "支付类型" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.payType) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "支付方式" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.wayCode) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "客户端IP" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.clientIp) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "用户标识" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailData.channelUser) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "渠道订单ID" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailData.channelOrderNo) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "异步通知地址" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.notifyUrl) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "页面跳转地址" } },
                          [_vm._v(" " + _vm._s(_vm.detailData.returnUrl) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "退款次数" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailData.refundTimes) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "退款总额" } },
                          [
                            _vm.detailData.refundAmount
                              ? _c("a-tag", { attrs: { color: "cyan" } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.detailData.refundAmount) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("a-divider"),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "订单分账模式" } },
                          [
                            _vm.detailData.divisionMode == 0
                              ? _c("span", [_vm._v("该笔订单不允许分账")])
                              : _vm.detailData.divisionMode == 1
                              ? _c("span", [
                                  _vm._v("支付成功按配置自动完成分账"),
                                ])
                              : _vm.detailData.divisionMode == 2
                              ? _c("span", [
                                  _vm._v("商户手动分账(解冻商户金额)"),
                                ])
                              : _c("span", [_vm._v("未知")]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { sm: 12 } },
                  [
                    _c(
                      "a-descriptions",
                      [
                        _c(
                          "a-descriptions-item",
                          { attrs: { label: "最新分账发起时间" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatTime(_vm.detailData.divisionLastTime)
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("a-divider"),
            _c(
              "a-row",
              { attrs: { justify: "start", type: "flex" } },
              [
                _c(
                  "a-col",
                  { attrs: { sm: 24 } },
                  [
                    _c(
                      "a-form-model-item",
                      { attrs: { label: "扩展参数" } },
                      [
                        _c("a-input", {
                          staticStyle: { height: "100px", color: "black" },
                          attrs: { type: "textarea", disabled: "disabled" },
                          model: {
                            value: _vm.detailData.extParam,
                            callback: function ($$v) {
                              _vm.$set(_vm.detailData, "extParam", $$v)
                            },
                            expression: "detailData.extParam",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _c("ExportRecordModal", {
        attrs: {
          visible: _vm.exportRecordVisible,
          reqTableDataFunc: _vm.getOrderExportList,
        },
        on: {
          close: function ($event) {
            _vm.exportRecordVisible = false
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }